import { Box } from "@mui/material";
import localize from "../../common/localize";

export default function CreatedByText({ entity }) {
  const getModificationDate = () => {
    return new Date(entity.ModificationDate).toLocaleString(undefined, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };
  return entity?.Id > 0 || entity?.id > 0 ? (
    <Box className="w-full flex mt-2">
      <Box className="two_columns_grid">
        <label className="event_detail_description">
          <b>{localize.modified_by}:</b>
        </label>
        <label className="event_detail_description">{`${
          entity.CreatedBy
        } (${getModificationDate()})`}</label>
      </Box>
    </Box>
  ) : (
    <></>
  );
}
